import { SendMessageContextFilter } from "@/services/messageService";
import { SearchOption } from "../base/SearchOption";
import Message from "./Message";

type Conversation = {
  id: string;
  title?: string;
  messages?: Message[];
  isWordConversation?: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  isDeleted?: boolean;
  userId?: string;
  messageCount?: number;
  toneOfVoiceId?: string;
  /** Cached prompt text locked at conversation creation (may be large). */
  toneOfVoice?: string;
  /** Snapshot of the tone profile title at creation (preferred chip label). */
  toneOfVoiceTitle?: string;
  /** Snapshot of the tone profile description at creation. */
  toneOfVoiceDescription?: string;
  searchOptions: SearchOption[];
  workspaceFilter: SendMessageContextFilter[];
};

/**
 * Id of the placeholder conversation shown between sending the first message and
 * the server assigning a real id. It is not addressable, so it must never reach
 * the URL (LAR-361).
 */
export const TEMP_CONVERSATION_ID = "temp-id";

export const emptyConversation: Conversation = {
  createdAt: "",
  updatedAt: "",
  id: "",
  title: "",
  messages: [],
  isWordConversation: false,
  isDeleted: false,
  messageCount: 0,
  toneOfVoiceId: undefined,
  toneOfVoice: undefined,
  toneOfVoiceTitle: undefined,
  toneOfVoiceDescription: undefined,
  searchOptions: [],
  workspaceFilter: [],
};

export default Conversation;
